"use client";

import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Inquire() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    const checkLang = () => {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    };
    checkLang();
    window.addEventListener("storage", checkLang);
    return () => window.removeEventListener("storage", checkLang);
  }, []);
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const line1 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.3
  });
  const line2 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.3
  });
  const line3 = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.3
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const cta = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const emailLink = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const horizon = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3186" id="inquire-about-products" className="relative overflow-hidden bg-background text-foreground py-40">
      <div className="container mx-auto px-6">
        <div className="mx-auto flex max-w-5xl flex-col items-center text-center">
          {}
          <div ref={eyebrow.ref} className="mb-12 transition-all duration-1000 ease-out" style={{
          opacity: eyebrow.isVisible ? 1 : 0,
          transform: eyebrow.isVisible ? "translateY(0)" : "translateY(20px)"
        }}>
            <p className="font-mono text-xs uppercase text-foreground" style={{
            letterSpacing: "0.25em"
          }}>
              {isZh ? "— 製造合作夥伴" : "— Manufacturing Partnerships"}
            </p>
          </div>

          {}
          <h2 className="mb-16 max-w-4xl font-default font-semibold leading-[1.05] text-foreground" style={{
          fontSize: "clamp(3rem, 6vw, 6rem)"
        }}>
            <span className="block overflow-hidden">
              <span ref={line1.ref} className="inline-block transition-all duration-1000 ease-out" style={{
              opacity: line1.isVisible ? 1 : 0,
              transform: line1.isVisible ? "translateY(0)" : "translateY(100%)",
              transitionDelay: "100ms"
            }}>
                {isZh ? "準備將您的" : "Ready to bring your"}
              </span>
            </span>
            <span className="block overflow-hidden">
              <span ref={line2.ref} className="inline-block transition-all duration-1000 ease-out" style={{
              opacity: line2.isVisible ? 1 : 0,
              transform: line2.isVisible ? "translateY(0)" : "translateY(100%)",
              transitionDelay: "300ms"
            }}>
                {isZh ? <>
                    <em className="italic text-primary">創意願景</em>推向
                  </> : <>
                    <em className="italic text-primary">vision</em> to the
                  </>}
              </span>
            </span>
            <span className="block overflow-hidden">
              <span ref={line3.ref} className="inline-block transition-all duration-1000 ease-out" style={{
              opacity: line3.isVisible ? 1 : 0,
              transform: line3.isVisible ? "translateY(0)" : "translateY(100%)",
              transitionDelay: "500ms"
            }}>
                {isZh ? "全球市場？" : "global market?"}
              </span>
            </span>
          </h2>

          {}
          <p ref={paragraph.ref} className="mb-12 max-w-xl font-default text-lg leading-relaxed text-foreground transition-all duration-1000 ease-out md:text-xl" style={{
          opacity: paragraph.isVisible ? 1 : 0,
          transform: paragraph.isVisible ? "translateY(0)" : "translateY(20px)",
          transitionDelay: "700ms"
        }}>
            {isZh ? "Elite Group 提供全方位一站式 OEM/ODM 製造解決方案。歡迎聯絡我們的專業團隊，共同探討您的客製化生產需求。" : "Elite Group provides end-to-end OEM/ODM manufacturing solutions. Connect with our team to discuss your production requirements."}
          </p>

          {}
          <div ref={cta.ref} className="mb-8 transition-all duration-1000 ease-out" style={{
          opacity: cta.isVisible ? 1 : 0,
          transform: cta.isVisible ? "translateY(0)" : "translateY(20px)",
          transitionDelay: "900ms"
        }}>
            <Button size="lg" className="group h-auto bg-primary px-12 py-5 font-default text-base font-semibold tracking-wide text-primary-foreground hover:bg-primary/90" asChild>
              <Link to="#">
                <span>{isZh ? "立即查詢" : "Start Your Inquiry"}</span>
                <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>

          {}
          <div ref={emailLink.ref} className="transition-all duration-1000 ease-out" style={{
          opacity: emailLink.isVisible ? 1 : 0,
          transform: emailLink.isVisible ? "translateY(0)" : "translateY(20px)",
          transitionDelay: "1100ms"
        }}>
            <Link to="#" className="font-default text-base italic text-foreground underline-offset-4 transition-colors duration-300 hover:text-primary hover:underline">
              {isZh ? "或直接聯絡我們香港辦事處" : "Or contact our Hong Kong office directly"}
            </Link>
          </div>
        </div>
      </div>

      {}
      <div ref={horizon.ref} className="mt-32 w-full transition-all duration-[1500ms] ease-out" style={{
      opacity: horizon.isVisible ? 1 : 0,
      transform: horizon.isVisible ? "translateY(0)" : "translateY(30px)",
      transitionDelay: "300ms"
    }}>
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0 80 Q 180 60, 360 75 T 720 70 T 1080 78 T 1440 65" stroke="var(--border)" strokeOpacity="0.5" strokeWidth="1" fill="none" />
          <path d="M0 95 Q 240 85, 480 92 T 960 88 T 1440 90" stroke="var(--border)" strokeOpacity="0.4" strokeWidth="1" fill="none" />
          <path d="M0 110 Q 360 102, 720 108 T 1440 105" stroke="var(--border)" strokeOpacity="0.3" strokeWidth="1" fill="none" />
          <circle cx="280" cy="55" r="1" fill="var(--primary)" fillOpacity="0.8" />
          <circle cx="720" cy="50" r="1.5" fill="var(--primary)" fillOpacity="0.7" />
          <circle cx="1180" cy="58" r="1" fill="var(--primary)" fillOpacity="0.8" />
        </svg>
      </div>
    </section>;
}